import React from 'react';

import 'react-responsive-carousel/lib/styles/carousel.min.css';
import '../../styles/carousel.css';
import {Carousel} from 'react-responsive-carousel';


export default function Udlap() {

    return (
        <div>
            <div>
                <Carousel dynamicHeight showArrows={false} showStatus={false} className="presentation-mode" showThumbs={false} autoPlay
                          interval={5000} infiniteLoop >
                    <div>
                        <img alt="Hector at UDLAP Robotics Demo" className="image" src="assets/udlap/roboticsTeam.png"/>
                    </div>
                    <div>
                        <img alt="Hector at UDLAP Engineering Building" className="image" src="assets/udlap/ingenieria.jpg"/>
                    </div>
                    <div>
                        <img alt="Hector at UDLAP Library" className="image" src="assets/udlap/udlap.jpg"/>
                    </div>
                </Carousel>
            </div>
            <div className="content">
                <h1>Universidad de las Americas, Puebla (UDLAP)</h1>
                <p>I studied a bachelors in engineering (BE) in Computational Systems. I wrote a thesis in Simulation of Articulated Robots with special emphasis in the Six Degrees-Of-Freedom robot known as PUMA. </p>
                <p>
                    UDLAP is one of the most prestiguous universities in Mexico. It is located in the oldest city in Latin America: Cholula. It is known for its combination of arts, culture, history, traditions and modernity.
                </p>
            </div>
        </div>
    );

}


// WEBPACK FOOTER //
// ./src/components/sections/Udlap.jsx